<template lang="pug">
  .base.badge-delegacion(:class="{'is-in-mobile': isMobile}",@click="showPopup = !showPopup")
    transition(name="fade")
      .background-popup-birthday(v-if="mostrarInactivarDelegación")
        .modal.is-active
          .card
            header.card-header
              p.card-header-title
                span Inactivar delegación
              a.card-header-icon
                span.icon
                  button.delete(@click="mostrarInactivarDelegación = false")
            .card-content
              .content
                strong(style="color:black") ¿Estás seguro de inactivar la delegación?
            footer.card-footer
              a.card-footer-item.is-success(@click="inactivar")
                span(v-if="isLoading") Inactivando...
                span(v-else) Inactivar
              a.card-footer-item( @click="mostrarInactivarDelegación = false")
                strong Cancelar
    strong {{  estoySiendoReemplazado ? 'Estás siendo reemplazado por' : estoyReemplazando ? 'Estás reemplazando a' : '' }} {{ isMobile ? nombreReemplazo : nombreReemplazoTrim }}
    transition(name="fade")
      .popup(
        v-if='showPopup'
        :class="{ 'popup-top': !isMobile, 'popup-bottom': isMobile }"
        v-on-clickaway="away"
        :style="{ bottom: isMobile ? badgeHeight + 'px' : 'none'}"
      )
        h3 {{  estoySiendoReemplazado ? 'Siendo reemplazado por' : estoyReemplazando ? 'Reemplazando a' : '' }}&nbsp;
          strong {{ nombreReemplazo }}
        p Fecha: {{ fechaInicioFormat == fechaFinFormat ? fechaInicioFormat : fechaInicioFormat + ' - ' + fechaFinFormat }}
        button.button.is-small.is-danger.mt-5(v-if="estoySiendoReemplazado", @click="mostrarInactivarDelegación = true")
          span.icon.is-small
            i.fa.fa-times
          span Inactivar

</template>
<script>
import moment from 'moment'
import { apiPost, notify } from '../util/general'
export default {
  name: 'c_delegaciones_mostrar_reemplazo',
  props: ['isMobile'],
  data () {
    return {
      showPopup: false,
      badgeHeight: 0,
      mostrarInactivarDelegación: false,
      isLoading: false
    }
  },
  computed: {
    estoySiendoReemplazado () {
      return this.$store.getters.estoySiendoReemplazado
    },
    estoyReemplazando () {
      return this.$store.getters.estoyReemplazando
    },
    nombreReemplazo () {
      return this.$store.getters.nombreReemplazo
    },
    nombreReemplazoTrim () {
      return this.nombreReemplazo.substring(0, 13) + '...'
    },
    fechaInicio () {
      return this.$store.getters.fechaInicio
    },
    fechaFin () {
      return this.$store.getters.fechaFin
    },
    id () {
      return this.$store.getters.id
    },
    codigoEmpleadoOrigen () {
      return this.$store.getters.codigoEmpleadoOrigen
    },
    codigoEmpleadoReemplazante () {
      return this.$store.getters.codigoEmpleadoReemplazante
    },
    fechaInicioFormat () {
      return moment(this.fechaInicio).format('DD/MM/YYYY')
    },
    fechaFinFormat () {
      return moment(this.fechaFin).format('DD/MM/YYYY')
    }
  },
  mounted () {
    let vm = this
    let node = document.querySelectorAll('.badge-delegacion.is-in-mobile')
    if (node && node.length > 0) {
      let height = node[0].clientHeight
      vm.badgeHeight = height
    }
  },
  methods: {

    inactivar () {
      var vm = this
      var obj = {
        fechaInicio                 : vm.fechaInicio,
        fechaFin                    : vm.fechaFin,
        codigoEmpleadoOrigen        : vm.codigoEmpleadoOrigen,
        codigoEmpleadoReemplazante  : vm.codigoEmpleadoReemplazante,
        activo                      : 0,
        id                          : vm.id
      }
      apiPost(vm, '/delegaciones', obj, function (data) {
        vm.$store.dispatch('setEstoyReemplazando', false)
        vm.$store.dispatch('setEstoySiendoReemplazado', false)
        vm.$store.dispatch('setNombreReemplazo', '')
        vm.$store.dispatch('setFechaInicio', '')
        vm.$store.dispatch('setFechaFin', '')
        vm.$store.dispatch('setId', 0)
        vm.$store.dispatch('setCodigoEmpleadoOrigen', 0)
        vm.$store.dispatch('setCodigoEmpleadoReemplazante', 0)
        notify(vm, 'success', 'Éxito', 'Inactivado correctamente')
        window.location.reload()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    away () {
      this.showPopup = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.base
  position: relative
  height: 30px;
  border-radius: 20px;
  background-color: #da07bf;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  cursor pointer
  z-index 11
  &:hover
    background-color #9a0687
  strong
    color #fff
  a
    strong
      color #363636
  i
    margin-left: 5px
    cursor: pointer
    font-size: 16px

.is-in-mobile
  border-radius: 0px;
  height: auto

.popup
  position absolute
  padding 10px
  height: fit-content
  background-color #fff
  color #363636
  border 1px solid #ccc
  z-index 999
  strong
    color #363636

.popup-bottom
  bottom: 0px
  width 250px
  background-color #f8f8f8


.popup-top
  top: 30px
  width 330px
  border-radius: 20px


</style>



// WEBPACK FOOTER //
// c_delegaciones_mostrar_reemplazo.vue?f00abdda